/*
 * bl_cart-bundle.js — behaviour for the customised-bottle bundle (bottle +
 * engraving/color-print service). The MERGE itself is server-rendered (see
 * snippets/bl_cart-bundle-role.liquid + bl_cart-bundle-service.liquid), so the
 * bundle is already correct on first paint and on every cart re-render — there
 * is no flash and the service line has no controls/links to act on.
 *
 * This script only adds two behaviours, both delegated so they survive re-renders:
 *   1. Collapse / expand the nested service details.
 *   2. Make the bottle's quantity + remove controls act on BOTH lines (the
 *      service has none of its own), intercepted in the capture phase before the
 *      theme's <line-item-quantity> handler runs.
 */
(function () {
  'use strict';
  if (window.__blCartBundleInit) return;
  window.__blCartBundleInit = true;

  var ROOT = document.documentElement;
  function root() { return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/'; }
  function isCartPage() {
    return !!(window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.pageType === 'cart');
  }

  // ── 1. Collapse / expand the nested service details ────────────────────────
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest && e.target.closest('[data-bl-toggle]');
    if (!toggle) return;
    e.preventDefault();
    var service = toggle.closest('[data-bl-service]');
    if (!service) return;
    var details = service.querySelector('.bl-bundle-service__details');
    var open = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', open ? 'false' : 'true');
    service.classList.toggle('bl-bundle--open', !open);
    if (details) details.hidden = open;
  });

  // ── 2. Bundle-wide quantity / remove (driven by the bottle's controls) ─────
  var busy = false;

  function combinedUpdate(updates) {
    return fetch(root() + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates, sections: ['mini-cart'], sections_url: window.location.pathname }),
    }).then(function (r) {
      if (!r.ok) throw new Error('update.js ' + r.status);
      return r.json();
    }).then(function (cart) {
      if (isCartPage()) { window.location.reload(); return; }
      // Mirror the theme's own post-change events so it re-renders everything.
      ROOT.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart: cart } }));
      ROOT.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail: { cart: cart, replacementDelay: 0 } }));
    });
  }

  function qtyFromHref(href) {
    try {
      var u = new URL(href, window.location.origin);
      var q = parseInt(u.searchParams.get('quantity'), 10);
      return Number.isNaN(q) ? null : q;
    } catch (e) { return null; }
  }

  // Any qty/remove control inside a bundled BOTTLE line acts on both members.
  function onCartAction(event) {
    var line = event.target.closest && event.target.closest('.line-item[data-bl-role="bottle"]');
    if (!line) return;

    var newQty = null;
    if (event.type === 'click') {
      var a = event.target.closest('a.quantity-selector__button, a.line-item__remove-button');
      if (a) newQty = qtyFromHref(a.getAttribute('href') || '');
    } else if (event.type === 'change') {
      var input = event.target.closest('input[name="updates[]"]');
      if (input) { var v = parseInt(input.value, 10); newQty = Number.isNaN(v) ? null : v; }
    }
    if (newQty === null) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    if (busy) return;
    busy = true;

    var updates = {};
    updates[line.getAttribute('data-bl-key')] = newQty;
    var serviceKey = line.getAttribute('data-bl-service-key');
    if (serviceKey) updates[serviceKey] = newQty;
    line.classList.add('bl-bundle--busy');
    combinedUpdate(updates).catch(function () {}).then(function () { busy = false; });
  }

  document.addEventListener('click', onCartAction, true);
  document.addEventListener('change', onCartAction, true);
})();
